<template>
  <TopGradientBlockLayout class="space-y-12 md:h-auto">
    <template #top>
      <MonthPicker v-if="layoutType === 'tablet'"
                   :date="currentMonth"
                   @change="$emit('changeMonth',$event)"/>
    </template>
    <CalendarTable :date="currentMonth"
                   :date-selected="dateSelected"
                   @selectDate="selectDate($event)"/>
    <CalendarTableLegend/>
    <CalendarSettingsInfo/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import CalendarTable from "@/components/cabinet/Money/Calendar/CalendarTable/CalendarTable";
import CalendarTableLegend from "@/components/cabinet/Money/Calendar/CalendarTable/CalendarTableLegend";
import IconHourGlass from "@/components/icons/IconHourGlass";
import IconInfo from "@/components/icons/IconInfo";
import {mapGetters, mapMutations, mapState} from "vuex";
import CalendarSettingsInfo from "@/components/cabinet/Money/Calendar/CalendarSettingsInfo";
import MonthPicker from "@/components/UI/MonthPicker";

export default {
  name: "CalendarMainView",
  components: {MonthPicker, CalendarSettingsInfo, CalendarTableLegend, CalendarTable, TopGradientBlockLayout},
  props: {
    currentMonth: {
      type: String
    }
  },
  computed: {
    ...mapGetters('theme', ['layoutType']),
    ...mapState('space/calendar', ['dateSelected'])
  },
  methods: {
    ...mapMutations('space/calendar', ['selectDate'])
  }
}
</script>